import React from 'react';
import Container from '@mui/material/Container';
import { Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'fi', label: 'FI', flag: '🇫🇮' },
  { code: 'en', label: 'EN', flag: '🇬🇧' },
];

const Lander = () => {
  const { t, i18n } = useTranslation();

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('varauslite-language', lang);
  };

  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        minWidth: 300,
        pt: '25vh',
        pb: 8,
      }}
    >
      <Button component={Link} to="/login" variant="contained" sx={{ minWidth: '50%' }}>
        {t('login.title')}
      </Button>

      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 1,
          py: 1.5,
          borderTop: '1px solid',
          borderColor: 'divider',
          backgroundColor: 'background.paper',
        }}
      >
        {languages.map(({ code, label, flag }) => (
          <Button
            key={code}
            onClick={() => handleLanguageChange(code)}
            variant={i18n.language === code ? 'contained' : 'outlined'}
            size="small"
            sx={{
              gap: 0.75,
              minWidth: 0,
              px: 1.5,
              fontSize: '0.875rem',
              textTransform: 'none',
            }}
          >
            <span style={{ fontSize: '1.1rem', lineHeight: 1 }}>{flag}</span>
            {label}
          </Button>
        ))}
      </Box>
    </Container>
  );
};

export default Lander;
